import { FunctionComponent, useState } from "react"
import AutoMap from "src/components/cbc/AutoMAP";
import { Button, PageContainer, PageTitle } from "src/components/generic";
import { TextInput } from "src/components/inputs";
import { useAuth } from "src/context/AuthContext";
import { userTypes } from "src/utils/types";


const ClaimMAP: FunctionComponent = () => {
    const [ssn, setSSN] = useState<string | null>(null);
    const [view, setView] = useState<'ssn' | 'map'>('ssn');

    const { user } = useAuth();

    const pull = () => {
        if(ssn && ssn?.length === 9) setView('map')
    }

    if(user?.userType !== userTypes.AccountTypes.CLIENT) return <p>Unauthorized</p>
    return (
        <PageContainer>
            <PageTitle title="CV MAP" />

            {
                (view === 'ssn') ? (
                    <TextInput 
                        id='ssn'
                        placeholder="Confim SSN"
                        onChange={(value: string) => setSSN(value)}
                        password
                    />
                ) : (
                    <AutoMap
                        client={user}
                        //@ts-ignore
                        ssn={ssn}
                    />
                )
            }

            {
                view === 'ssn' && (
                    <Button text="Pull Credit" onClick={pull} />
                )
            }
        </PageContainer>
    )
}

export default ClaimMAP;